import * as React from "react";
import { memo } from "react";
import styled, { ThemeContext } from "styled-components";
import { themeGet } from "@styled-system/theme-get";
import { Text } from "pcln-design-system";
const IconWrapper = /*#__PURE__*/styled(Text).withConfig({
  displayName: "HotelsDark__IconWrapper",
  componentId: "sc-bvn44n-0"
})(["display:inline-block;"]);
function BaseComponent({
  title,
  titleId,
  ...props
}) {
  const themeContext = React.useContext(ThemeContext);
  const themeProps = {
    theme: themeContext
  };
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: false,
    "aria-hidden": true,
    role: "img",
    "aria-labelledby": titleId,
    ...props
  }, title ? React.createElement("title", {
    id: titleId
  }, title) : null, React.createElement("path", {
    d: "M8.714 2.822h16.4M10.21 2.822v22.07M23.625 2.822v22.07",
    stroke: themeGet("palette.background.darkest")(themeProps),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M10.21 12.87H4.644v12.025l-2.68 3.283h29.872l-2.644-3.283V12.87h-5.567",
    stroke: themeGet("palette.background.darkest")(themeProps),
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M14.635 13.855h-.88a.539.539 0 00-.539.539v.88c0 .297.242.538.54.538h.879a.539.539 0 00.538-.539v-.88a.539.539 0 00-.538-.538zM20.08 13.855h-.88a.539.539 0 00-.538.539v.88c0 .297.241.538.539.538h.879a.539.539 0 00.539-.539v-.88a.539.539 0 00-.54-.538zM14.635 6.637h-.88a.539.539 0 00-.539.539v.879c0 .297.242.539.54.539h.879a.539.539 0 00.538-.54v-.878a.539.539 0 00-.538-.54zM20.08 6.637h-.88a.539.539 0 00-.538.539v.879c0 .297.241.539.539.539h.879a.539.539 0 00.539-.54v-.878a.539.539 0 00-.54-.54zM14.635 10.246h-.88a.539.539 0 00-.539.539v.879c0 .297.242.539.54.539h.879a.539.539 0 00.538-.54v-.878a.539.539 0 00-.538-.54zM20.08 10.246h-.88a.539.539 0 00-.538.539v.879c0 .297.241.539.539.539h.879a.539.539 0 00.539-.54v-.878a.539.539 0 00-.54-.54zM7.863 16.06h-.88a.539.539 0 00-.538.54v.878c0 .298.241.54.539.54h.879a.539.539 0 00.539-.54V16.6a.539.539 0 00-.539-.539zM7.863 19.967h-.88a.539.539 0 00-.538.54v.878c0 .298.241.54.539.54h.879a.539.539 0 00.539-.54v-.879a.539.539 0 00-.539-.539zM26.852 15.947h-.88a.539.539 0 00-.538.539v.879c0 .298.24.539.538.539h.88a.539.539 0 00.539-.539v-.88a.539.539 0 00-.54-.538zM26.852 19.854h-.88a.539.539 0 00-.538.539v.879c0 .298.24.539.538.539h.88a.539.539 0 00.539-.539v-.88a.539.539 0 00-.54-.538z",
    fill: themeGet("palette.background.darkest")(themeProps)
  }), React.createElement("path", {
    d: "M29.17 24.895H4.623",
    stroke: themeGet("palette.background.darkest")(themeProps),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M16.102 18.627h-2.347c-.297 0-.539.196-.539.438v4.898c0 .241.242.438.54.438h2.346c.298 0 .54-.197.54-.438v-4.898c0-.242-.242-.438-.54-.438zM20.102 18.627h-2.348c-.297 0-.538.196-.538.438v4.898c0 .241.24.438.538.438h2.348c.297 0 .538-.197.538-.438v-4.898c0-.242-.24-.438-.538-.438z",
    fill: themeGet("palette.background.darkest")(themeProps)
  }));
}
const HotelsDark = props => React.createElement(IconWrapper, {
  fontSize: props.size,
  lineHeight: props.size,
  verticalAlign: "middle",
  className: props.className
}, React.createElement(BaseComponent, null));
/** @public */
const Memo = memo(HotelsDark);
export default Memo;